import { render, staticRenderFns } from "./PhenotypePicker.vue?vue&type=template&id=5649b454&"
import script from "./PhenotypePicker.vue?vue&type=script&lang=js&"
export * from "./PhenotypePicker.vue?vue&type=script&lang=js&"
import style0 from "./PhenotypePicker.vue?vue&type=style&index=0&id=5649b454&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5649b454')) {
      api.createRecord('5649b454', component.options)
    } else {
      api.reload('5649b454', component.options)
    }
    module.hot.accept("./PhenotypePicker.vue?vue&type=template&id=5649b454&", function () {
      api.rerender('5649b454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PhenotypePicker.vue"
export default component.exports